import { useNavigator } from '@repo/toolkit/use-navigator'
import { SettingIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createPromoCode } from '../../../api/promo-codes/create-promo-code'
import UserNavBar from '../../../components/elements/nav-bar'
import PromoCodeForm from '../../../components/pages/promo-code/promo-code-form'
import { Paths } from '../../../lib/constants/path'
import { PromoCodeApplicationEnum } from '../../../lib/types/enums/promo-code/promo-code-application.enum'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const PromoCodeCreatePage = () => {
  const { back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createPromoCode,
    onError: showAxiosError,
    onSuccess: () => toast.success('Code promo créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un code promo'} icon={SettingIcon} />
      <div className={'h-4'} />
      <PromoCodeForm
        defaultValues={{ application: PromoCodeApplicationEnum.MANUAL }}
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            await mutateAsync(values)
            back(Paths.PROMO_CODE_LIST_PAGE)
          },
          onCancel: () => back(Paths.PROMO_CODE_LIST_PAGE)
        })}
      />
    </div>
  )
}

export default PromoCodeCreatePage
